import { render } from "./Banner.vue?vue&type=template&id=4c802c28"
import script from "./Banner.js?vue&type=script&lang=js"
export * from "./Banner.js?vue&type=script&lang=js"

import "./Banner.scss?vue&type=style&index=0&lang=scss"
import "./Banner.vue?vue&type=style&index=1&id=4c802c28&lang=css"
/* custom blocks */
import block0 from "./Banner.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FBanner%2FBanner.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__